import { render } from "./Experts.vue?vue&type=template&id=6478bd6c"
import script from "./Experts.vue?vue&type=script&lang=js"
export * from "./Experts.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__